import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  body: {
    "& .MuiPaper-root": {
      backgroundColor: theme.design.color.surface.raised,
      color: theme.design.color.text.primary,
      display: "flex",
      flexDirection: "column",
      borderRadius: "16px",
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      gap: 8,

      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
  },

  modalContent: {
    position: "relative",
  },

  contentBody: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "32px 96px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 22px",
    },
  },

  closeIconBody: {
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    right: 25,
    top: 25,
    "&>button": {
      padding: 0,
      minWidth: "auto",
      "&>svg": {
        color: theme.design.color.text.secondary,
        cursor: "pointer",
        transition: ".3s",
        width: theme.design.size.icon.lg,
        height: theme.design.size.icon.lg,
        "&:hover": {
          color: theme.design.color.text.primary,
          transition: ".3s",
        },
      },
    },
  },

  logoImg: {
    width: 48,
  },

  titleText: {
    fontSize: 24,
  },

  mafiaImg: {
    width: 80,
    marginTop: 16,
  },

  tryAgainText: {
    fontSize: 14,
  },

  remainTimeBox: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    marginTop: 8,
  },

  remainTime: {
    color: theme.design.color.text.muted,
  },

  clockImg: {
    width: 24,
  },
}));

export default styles;
